export default __webpack_public_path__ + "static/media/piece.c6b8cd0c.png";